import { render } from "./GKENodePool.vue?vue&type=template&id=287067e2&scoped=true&ts=true"
import script from "./GKENodePool.vue?vue&type=script&lang=ts"
export * from "./GKENodePool.vue?vue&type=script&lang=ts"

import "./GKENodePool.vue?vue&type=style&index=0&id=287067e2&lang=scss&scoped=true"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-287067e2"]])

export default __exports__